export default defineNuxtRouteMiddleware(async (to, from) => {
  const userStore = useUserStore()
  const navigationStore = useNavigationStore()
  const config = useRuntimeConfig()

  const isLoged = userStore.isUserLoged
  // Survey
  const redirection = navigationStore.redirection
  const tokenSurvey = userStore.survey?.id
  const querySurvey = to.query?.surveyId
  const queryReport = to.query?.reportId
  const queryEncounter = to.query?.encounterId
  const queryPatient = to.query?.patientId
  const queryEoc = to.query?.episodeOfCareId

  if (to.path.includes('/auth/psc-login')) {
    window.location.href = config.public.BACK_URL + '/auth/external/pro-sante-connect'
    return
  }

  if (to.path.includes('/auth/france-connect-login')) {
    window.location.href = config.public.BACK_URL + '/auth/external/france-connect'
    return
  }

  if (queryReport && queryEoc) {
    navigationStore.addReportEoc(queryEoc)
  }

  if (queryEncounter && queryEoc) {
    navigationStore.addReportEoc(queryEoc)
  }

  if (redirection && isLoged) {
    navigationStore.clear()
  } else if (tokenSurvey && !to.path.includes('/survey/')) {
    let url = `/survey/${tokenSurvey}`
    if (queryPatient) url += `?patientId=${queryPatient}`
    window.location.href = url
    return
  } else if (querySurvey && isLoged) {
    let url = `/survey/${querySurvey}`
    if (queryPatient) url += `?patientId=${queryPatient}`
    window.location.href = url
    return
  } else if (querySurvey) {
    navigationStore.addSurvey('/survey/' + querySurvey)
  } else if (queryReport && isLoged) {
    let url = `/report/${queryReport}`
    if (queryPatient) url += `?patientId=${queryPatient}`
    window.location.href = url
    return
  } else if (queryReport) {
    navigationStore.addReport('/report/' + queryReport)
  } else if (queryEncounter && isLoged) {
    let url = `/encounters/${queryEncounter}`
    if (queryPatient && queryEoc) url += `?patientId=${queryPatient}&episodeOfCareId=${queryEoc}`
    window.location.href = url
    return
  } else if (queryEncounter) {
    navigationStore.addEncounter(`/encounters/${queryEncounter}`)
  }
})
